import { render, staticRenderFns } from "./MerchantEdit.vue?vue&type=template&id=b4926422&scoped=true&"
import script from "./MerchantEdit.vue?vue&type=script&lang=js&"
export * from "./MerchantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4926422",
  null
  
)

export default component.exports